import { PayloadAction } from '@reduxjs/toolkit';
import { ThemePack } from '@/types/theme-packs.types';
import { TemplatesReducerCreator } from '../types';

const setThemePackReducer = (create: TemplatesReducerCreator) => {
  return create.reducer((state, action: PayloadAction<ThemePack>) => {
    state.themePacks = state.themePacks?.map((theme) => {
      if (theme.color_pack === action.payload.color_pack) {
        return action.payload;
      }
      return theme;
    }) || [action.payload];
  });
};

export default setThemePackReducer;
